(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-week-2026-exclusives"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('member-week-exclusives')) {
    class MemberWeekExclusives extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleSectionLoad = this.handleSectionLoad.bind(this);
        this.handleSlideChange = this.handleSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleDocumentReady = this.initialize.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        window.addEventListener('resize', this.handleResize);
        if (document.readyState !== 'complete') {
          document.addEventListener('DOMContentLoaded', this.handleDocumentReady, { once: true });
        }
        this.initialize();
        this.initializationFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initializationFrame);
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('DOMContentLoaded', this.handleDocumentReady);
        this.cleanupSwiper();
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      }

      initialize() {
        const activePanelId = this.activePanelId;
        this.tabs = Array.from(this.querySelectorAll('[data-member-exclusives-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-member-exclusives-panel]'));
        const container = this.querySelector('[data-compare-groups]');
        if (this.swiperContainer !== container || (this.groupSwiper && this.groupSwiper.destroyed)) {
          this.cleanupSwiper();
        }
        this.swiperContainer = container;
        if (!this.tabs.length) return;
        if (!this.groupSwiper && container) {
          if ((container.swiper && !container.swiper.destroyed) || typeof window.Swiper === 'function') {
            this.panels.forEach((panel) => {
              panel.hidden = false;
            });
            container.setAttribute('data-swiper-ready', '');
          }
          if (container.swiper && !container.swiper.destroyed) {
            this.groupSwiper = container.swiper;
          } else if (typeof window.Swiper === 'function') {
            try {
              this.groupSwiper = new window.Swiper(container, {
                slidesPerView: 1,
                allowTouchMove: false,
                autoHeight: true,
              });
              this.ownsGroupSwiper = true;
            } catch (error) {
              this.groupSwiper = null;
            }
          }
        }
        if (container) container.toggleAttribute('data-swiper-ready', Boolean(this.groupSwiper));
        if (this.groupSwiper && this.subscribedSwiper !== this.groupSwiper) {
          this.groupSwiper.on('slideChange', this.handleSlideChange);
          this.subscribedSwiper = this.groupSwiper;
        }
        const activeIndex = this.groupSwiper
          ? this.groupSwiper.activeIndex || 0
          : this.panels.findIndex((panel) => panel.id === activePanelId);
        this.updateGroupState(activeIndex < 0 ? 0 : activeIndex);
        if (this.groupSwiper) this.groupSwiper.updateAutoHeight(0);
      }

      cleanupSwiper() {
        if (this.subscribedSwiper && !this.subscribedSwiper.destroyed) {
          this.subscribedSwiper.off('slideChange', this.handleSlideChange);
        }
        if (this.ownsGroupSwiper && this.groupSwiper && !this.groupSwiper.destroyed) {
          this.groupSwiper.destroy(true, true);
        }
        this.groupSwiper = null;
        this.subscribedSwiper = null;
        this.ownsGroupSwiper = false;
      }

      updateGroupState(index) {
        if (!this.tabs.length) return;
        const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.activePanelId = this.tabs[safeIndex].getAttribute('aria-controls');
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === safeIndex;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          tab.parentElement.classList.toggle('is-active', active);
        });
        this.panels.forEach((panel) => {
          const active = panel.id === this.activePanelId;
          panel.hidden = !this.groupSwiper && !active;
          panel.inert = !active;
          panel.setAttribute('aria-hidden', String(!active));
          panel.tabIndex = active ? 0 : -1;
        });
      }

      activateTab(index, moveFocus = false) {
        if (!this.tabs || !this.tabs[index]) return;
        this.updateGroupState(index);
        if (this.groupSwiper && this.groupSwiper.activeIndex !== index) this.groupSwiper.slideTo(index);
        if (moveFocus) this.tabs[index].focus();
      }

      handleSlideChange() {
        this.updateGroupState(this.groupSwiper.activeIndex || 0);
      }

      handleResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (this.isConnected && this.groupSwiper && !this.groupSwiper.destroyed) {
            this.groupSwiper.updateAutoHeight(0);
          }
        }, 200);
      }

      handleClick(event) {
        const group = event.target.closest('.p-compare-group-name');
        const tab = group && group.querySelector('[data-member-exclusives-tab]');
        if (!tab || !this.tabs) return;
        this.activateTab(this.tabs.indexOf(tab));
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-member-exclusives-tab]');
        if (!tab || !this.tabs) return;
        const index = this.tabs.indexOf(tab);
        let targetIndex;
        switch (event.key) {
          case 'ArrowLeft':
            targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'ArrowRight':
            targetIndex = (index + 1) % this.tabs.length;
            break;
          case 'Home':
            targetIndex = 0;
            break;
          case 'End':
            targetIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        this.activateTab(targetIndex, true);
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target) || !this.panels) return;
        const panel = event.target.closest('[data-member-exclusives-panel]');
        if (panel) this.activateTab(this.panels.indexOf(panel));
      }

      handleSectionLoad(event) {
        if (event.target.contains(this)) this.initialize();
      }
    }
    customElements.define('member-week-exclusives', MemberWeekExclusives);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-custom-collection-series"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var mySwiper = new Swiper('.new-custom-collection-series.swiper', {
      loop: false,
      slidesPerView: 6,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1550: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z2-collection-cleaning-system"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.cleaningSystemSwiper')) {
      new Swiper('.cleaningSystemSwiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
          el: '.cleaningSystemSwiper .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.cleaning-system-next',
          prevEl: '.cleaning-system-prev',
        },
        breakpoints: {
          768: { slidesPerView: 1 },
          850: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z2-collection-level"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.levelSwiper')) {
      const swiper = new Swiper('.levelSwiper', {
        slidesPerView: 1.8,
        spaceBetween: 24,
        initialSlide: 0,
        pagination: {
          el: '.levelSwiper .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: { centeredSlides: false, allowTouchMove: true },
          850: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },
        },
      });

      function updateSwiper() {
        if (window.innerWidth >= 850) {
          swiper.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;
        }
      }

      updateSwiper();

      window.addEventListener('resize', function () {
        updateSwiper();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
